import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";
import { callApi } from "../../ApiHelper/ApiHelper";
import { apiUrl } from "../../ApiHelper/ApiUrl";

const RefundForm = () => {
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
        setValue
    } = useForm();
    const [loading, setLoading] = useState(false);

    const onSubmit = (data) => {
        setLoading(true);
        callApi(apiUrl.refund_request, {
            method: "POST",
            data: data
        }).then((response) => {
            setLoading(false);
            if (response?.status) {
                toast.success(response?.message);
                reset();
            } else {
                toast.error(response?.message);
            }
        })
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-group mb-4">
                <label htmlFor="planDetail">Plan Name</label>
                <select
                    className={`form-control ${errors.planDetail ? "is-invalid" : ""}`}
                    id="planDetail"
                    defaultValue=""
                    {...register("planDetail", {
                        required: "plan name is required",
                    })}
                >
                    <option value="" disabled hidden>
                        Select Plan
                    </option>
                    <option value="Annual">Annual Plan</option>
                    <option value="Quarterly">Quarterly Plan</option>
                    <option value="Branch purchase">Branch Plan</option>
                    <option value="Branch purchase">Employee Plan</option>
                    <option value="Branch renew">Branch Renew</option>
                    <option value="Employee renew">Employee Renew</option>
                </select>
                {errors.planDetail && (
                    <small className="text-danger">{errors.planDetail.message}</small>
                )}
            </div>
            <div className="form-group mb-4">
                <label htmlFor="username">Transporter Name</label>
                <input
                    className={`form-control ${errors.username ? "is-invalid" : ""}`}
                    id="username"
                    type="text"
                    placeholder="Enter transporter name"
                    {...register("username", {
                        required: "Transporter name is required",
                    })}
                />
                {errors.username && (
                    <small className="text-danger">{errors.username.message}</small>
                )}
            </div>
            <div className="form-group mb-4">
                <label htmlFor="contactNo">Contact No.</label>
                <input
                    className={`form-control ${errors.contactNo ? "is-invalid" : ""}`}
                    type="text"
                    id="contactNo"
                    placeholder="Enter Contact No."
                    {...register("contactNo", {
                        required: "Contact No is required",
                    })}
                    onChange={(e) => {
                        const onlyNumbers = e.target.value.replace(/[^0-9]/g, "");
                        setValue("contactNo", onlyNumbers, { shouldValidate: true });
                    }}
                />
                <small className="text-secondary">Note: Please enter the registered bilty contact number </small><br />
                {errors.contactNo && (
                    <small className="text-danger">{errors.contactNo.message}</small>
                )}
            </div>
            <div className="form-group mb-4">
                <label htmlFor="rejectReason">Reason for Refund <span className="text-danger">*</span></label>
                <select
                    className={`form-control ${errors.rejectReason ? "is-invalid" : ""}`}
                    id="reason"
                    defaultValue=""
                    {...register("rejectReason", {
                        required: "Please select a reason for refund",
                    })}
                >
                    <option value="" disabled hidden>
                        Select Reason
                    </option>
                    <option value="Accidental Purchase">Accidental Purchase</option>
                    <option value="Didn’t Use the Service">Didn’t Use the Service</option>
                    <option value="Amount deducted, no plan activation">Amount deducted, no plan activation</option>
                    <option value="Renewed Without Notice">Renewed Without Notice</option>
                    <option value="Not Satisfied with Features/Service">Not Satisfied with Features/Service</option>
                    <option value="Technical Issues">Technical Issues</option>
                    <option value="Overcharged or Double Charged">Overcharged or Double Charged</option>
                    <option value="Trial Conversion Issue">Trial Conversion Issue</option>
                    <option value="Financial Reasons">Financial Reasons</option>
                    <option value="other">Other</option>
                </select>
                {errors.rejectReason && (
                    <small className="text-danger">{errors.rejectReason.message}</small>
                )}
            </div>

            <div className="form-group mb-4">
                <label htmlFor="comment">Comments</label>
                <textarea
                    className={`form-control ${errors.comment ? "is-invalid" : ""}`}
                    id="comment"
                    rows={3}
                    {...register("comment", {
                        required: "Comment is required",
                    })}
                    placeholder="Enter comment"
                />
                {errors.comment && (
                    <small className="text-danger">{errors.comment.message}</small>
                )}
            </div>

            <button className="btn puprple_btn" type="submit" disabled={loading}>
                {loading ? <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div> : "Submit Request"}
            </button>
        </form>
    );
};

export default RefundForm;
